/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'announcements': {
    width: 200.195,
    height: 200,
    viewBox: '0 0 1025 1024',
    data: '<defs/><path pid="0" d="M1024.064 405.728v453.728q0 37.728-26.848 64.576T932.64 950.88H91.488q-37.728 0-64.576-26.848T.064 859.456V405.728q25.152 28 57.728 49.728 206.848 140.576 284 197.152 32.576 24 52.864 37.44t54.016 27.424 62.848 14.016h1.152q29.152 0 62.848-14.016t54.016-27.424 52.864-37.44q97.152-70.272 284.576-197.152 32.576-22.272 57.152-49.728zm0-168q0 45.152-28 86.272t-69.728 70.272Q711.488 543.424 658.912 580q-5.728 4-24.288 17.44t-30.848 21.728-29.728 18.56-32.864 15.424-28.576 5.152h-1.152q-13.152 0-28.576-5.152t-32.864-15.424-29.728-18.56-30.848-21.728T365.152 580q-52-36.576-149.728-104.288t-117.152-81.44q-35.424-24-66.848-66.016T0 250.24q0-44.576 23.712-74.272t67.712-29.728h841.152q37.152 0 64.288 26.848T1024 237.664z" _fill="#555"/>'
  }
})
